module.exports = __webpack_public_path__ + "static/media/cesura-14.45fc9292.jpg";